import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseBrandFormPayload } from '@hooks/useBrand'

import ToggleListItem from '@components/ToggleListItem'

import { toggleNestedValue } from '@functions/entity'

interface AdditionalSettingsProps {
  brandFormPayload: UseBrandFormPayload,
}

const AdditionalSettings = (props: AdditionalSettingsProps) => {
  const { brandFormPayload } = props

  const {
    entityState: {
      options,
    },
  } = brandFormPayload

  const {
    red_alert,
  } = options

  return (
    <DashboardModule title="Additional Settings">
      <Form padding="large" boxProps={{ paddingBottom: 'medium' }}>
        <ToggleListItem
          onClick={() => toggleNestedValue(brandFormPayload, 'options.red_alert', { shouldSetState: true })}
          toggleValue={red_alert}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>Red Alert</ToggleListItem.Title>

          <ToggleListItem.Description>
            Brand will be set to Red Alert
          </ToggleListItem.Description>
        </ToggleListItem>
      </Form>
    </DashboardModule>

  )
}
export default AdditionalSettings
